import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Form, Box, TextButton, Link } from 'bonfire-kindling';
import { useAuth } from 'providers/AuthProvider';

export default () => {
  const { t } = useTranslation();
  const { login } = useAuth();

  const { isLoading, isError, mutate } = useMutation(({ email, password }) =>
    login(email, password)
  );

  const onSubmit = ({ email, password }) => {
    return mutate({ email, password });
  };

  return (
    <Form onSubmit={onSubmit} initialValues={{ email: '', password: '' }}>
      {({ handleSubmit, pristine }) => (
        <form onSubmit={handleSubmit}>
          <Form.TextField
            required
            fullWidth
            label={t('login.email')}
            name="email"
            type="email"
            disabled={isLoading}
            sx={{ mt: 5 }}
          />
          <Box position="relative" mt={3}>
            <Link
              variant="caption"
              href={`${process.env.REACT_APP_DEFAULT_ORGANIZATION_BASE_URL}/login/forgot`}
              openInNew
              sx={{ position: 'absolute', right: 0, top: '0.25rem', zIndex: 1 }}
            >
              {t('login.forgot')}
            </Link>
            <Form.TextField
              label={t('login.password')}
              required
              fullWidth
              error={isError}
              helperText={isError ? t('login.incorrect_credentials') : null}
              name="password"
              type="password"
              disabled={isLoading}
              margin="none"
            />
          </Box>
          <Box mt={3} display="flex" justifyContent="center" alignItems="center">
            <TextButton
              variant="contained"
              color="primary"
              type="submit"
              isBusy={isLoading}
              disabled={pristine}
              label={t('login.login_label')}
            />
          </Box>
        </form>
      )}
    </Form>
  );
};
